import {getImage} from "../../constants/constants";
import React, {useEffect, useState} from "react";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_PLAYER_DATA_API} from "../../constants/api_constants";
import PlayerDetailCard from "./PlayerDetailCard";
import neverLandUtils from "../../utils/NeverLandUtils";

const PlayGround = ({homeTeamData, awayTeamData, dataId, playerDataDetails}) => {
  const [homePlayerCode, setHomePlayerCode] = useState(null);
  const [homePlayerData, setHomePlayerData] = useState(null);

  const [awayPlayerCode, setAwayPlayerCode] = useState(null);
  const [awayPlayerData, setAwayPlayerData] = useState(null);

  function parseCssString(cssString) {
    // 선수 위치 css 텍스트 변환해서 띄우기
    const styles = {};
    cssString.split(";").forEach((rule) => {
      if (rule.trim()) {
        const [property, value] = rule.split(":").map((s) => s.trim());
        styles[property] = value;
      }
    });
    return styles;
  }

  // ------------ 홈 선수 상세 정보 불러오기 ------------
  useEffect(() => {
    if (homePlayerCode === null) {
      setHomePlayerData(null);
      return;
    } else {
      getHomePlayerData(homePlayerCode);
    }
  }, [homePlayerCode]);

  const getHomePlayerData = (playerCode) => {
    // 선택한 홈팀 선수 상세정보 불러오기
    getFetcherAnalysis().get(GET_PLAYER_DATA_API + `?dataId=${dataId}&playerCode=${playerCode}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            setHomePlayerData(data);
          } else {
            console.log(responseResultDescription);
          }
        }).catch(err => console.log(err));
  }

  // ------------ 원정 선수 상세 정보 불러오기 ------------
  useEffect(() => {
    if (awayPlayerCode === null) {
      setAwayPlayerData(null);
      return;
    } else {
      getAwayPlayerData(awayPlayerCode);
    }
  }, [awayPlayerCode]);

  const getAwayPlayerData = (playerCode) => {
    // 선택한 원정팀 선수 상세정보 불러오기
    getFetcherAnalysis().get(GET_PLAYER_DATA_API + `?dataId=${dataId}&playerCode=${playerCode}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            setAwayPlayerData(data);
          } else {
            console.log(responseResultDescription);
          }
        }).catch(err => console.log(err));
  }

  function getPlayerDetailsByPlayerCode(player) {
    // 변경되는 선수 리스트가 있으면 선수코드로 찾아서 해당 값 변경
    if (playerDataDetails.list && playerDataDetails.list.length > 0) {
      // 처음 가지고오는 데이터와 평점 데이터가 일치하지않아서 평점(옵션1-1/옵션2-1)은 원본띄우고있음
      let isFailData = playerDataDetails.option1 === 1 && playerDataDetails.option2 === 1;
      for (var playerDetail of playerDataDetails.list) {
        if (playerDetail.code === player.code) {
          if (isFailData) {
            return player.rate;
          } else {
            return playerDetail.val;
          }
        }
      }
      // 리스트에 코드가 없는 선수는 원본 반환
      return player.rate;
    }
    // 변경되는 리스트가 없으면 원본 반환
    return player.rate;
  }

  return (
      <div>
        {/* <-------------- 홈팀 ------------> */}
        <div className="text-xs">

          {/* 벤치 플레이어 */}
          <div
              className="flex flex-row justify-start items-center bg-green-800 text-white w-full whitespace-nowrap overflow-scroll [&::-webkit-scrollbar]:hidden"
              style={{
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
          >
            <p className="text-xl py-2 bg-red-600 px-2 mr-3">
              홈팀
              {/*{playerDataDetails.updateDate?.toString()}*/}
            </p>

            <div className="flex flex-row mt-1">
              {homeTeamData?.BENCH_PLAYER?.map((player) => {
                let playerDetails = getPlayerDetailsByPlayerCode(player);

                if (playerDetails === '0.00') {
                  playerDetails = "-";
                }
                return (
                    <div
                        className="flex flex-col justify-center items-center mr-3"
                    >
                      <p className=" bg-red-500 text-black rounded-full px-2 py-1 min-w-9 text-center h-6"
                         onClick={() => setHomePlayerCode(player.code)}
                      >
                        {playerDetails === '-' ? "" : playerDetails}
                      </p>
                      <p>{player.name}</p>
                    </div>
                )
              })}
            </div>
          </div>
          {/* 운동장 */}
          <div
              className="relative flex flex-wrap justify-center items-center w-full"
              style={{
                backgroundImage: `url(${getImage("soccer_ground")})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "32rem",
              }}
          >
            <div className="absolute w-full h-full">
              <div className="text-white absolute w-8 h-32 flex flex-col justify-center items-center text-center"
                   style={{
                     position: 'relative',
                     top: "75%",
                     left: "calc(1%)",
                   }}
              >
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                      backgroundImage: `url(${getImage("arrow_home")})`,
                      backgroundSize: "100% 100%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      opacity: 0.5,
                    }}
                />
                <p className="[writing-mode:vertical-rl] [text-orientation:upright] z-10 mb-3">
                  오른쪽공격
                </p>
                <p className="h-3 mb-3 z-10">{homeTeamData.ATTACK_RIGHT}</p>
              </div>

              <div className="text-white absolute w-16 h-11 flex flex-col justify-center items-center text-center"
                   style={{
                     position: 'relative',
                     top: "65.5%",
                     left: "calc(41%)",
                   }}
              >
                <div
                    className="absolute inset-0"
                    style={{
                      backgroundImage: `url(${getImage("arrow_home")})`,
                      backgroundSize: "100% 100%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      opacity: 0.5,
                    }}
                />
                <p className="z-10">중앙공격</p>
                <p className="z-10">{homeTeamData.ATTACK_MIDDLE}</p>
              </div>

              <div className="text-white absolute w-8 h-32 flex flex-col justify-center items-center text-center"
                   style={{
                     position: 'relative',
                     top: "40%",
                     left: "calc(90%)",
                   }}
              >
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                      backgroundImage: `url(${getImage("arrow_home")})`,
                      backgroundSize: "100% 100%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      opacity: 0.5,
                    }}
                />
                <p className="[writing-mode:vertical-rl] [text-orientation:upright] mb-3 z-10">
                  왼쪽공격
                </p>
                <p className="h-3 mb-3 z-10">{homeTeamData.ATTACK_LEFT}</p>
              </div>
            </div>

            {/* 선택한 선수 정보 */}
            {homePlayerData && <PlayerDetailCard playerData={homePlayerData[0]} setPlayerCode={setHomePlayerCode}/>}

            {/* 운동장 선수 */}
            <div
                className="absolute inset-0 w-full h-[calc(100%-3rem)] transform translate-x-6 translate-y-2 text-white">
              {homeTeamData?.PLAYER?.map((player, index) => {
                const parsedStyles = parseCssString(player.cssHorizontal || "");
                let playerDetails = getPlayerDetailsByPlayerCode(player);

                if (playerDetails === '0.00') {
                  playerDetails = "-";
                }
                return (
                    <div
                        key={index}
                        className={neverLandUtils.classNames(playerDetails === "-" ? "opacity-50" : "", "absolute flex flex-col justify-center items-center")}
                        style={{
                          top: parsedStyles.top,
                          right: parsedStyles.right,
                        }}
                    >
                      {/*휴식일 / 키*/}
                      <div
                          className="flex flex-row justify-center p-1"
                      >
                        <p>{player.fday === "-" ? "" : player.fday + "일"}</p>
                        {player.height && <p>/{player.height}</p>}
                      </div>

                      {/*평점*/}
                      <div
                          className="flex flex-col bg-red-600 rounded-full justify-center items-center p-2 min-w-11 h-7"
                          onClick={() => setHomePlayerCode(player.code)}
                      >
                        <p>{playerDetails === '-' ? "" : playerDetails}</p>
                      </div>

                      {/*이름*/}
                      <p className="w-20 text-xs text-white text-center p-1 whitespace-nowrap overflow-hidden text-ellipsis truncate">
                        {player.name}
                      </p>

                      {/* 골키퍼일때 세이브 띄우기 */}
                      {(player.gk === '1' && player.saver_per) &&
                          <p className="text-xs text-white text-center p-1">
                            [ 세이브 : {player.saver_per} ]
                          </p>
                      }
                    </div>
                )
              })}
            </div>
          </div>
        </div>

        {/* <-------------- 원정팀 ------------> */}
        <div className="text-xs">
          {/* 운동장 */}
          <div
              className="relative flex flex-wrap justify-center items-center w-full"
              style={{
                backgroundImage: `url(${getImage("soccer_ground_away")})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                height: "32rem",
              }}
          >
            <div className="absolute w-full h-full">

              <div className="text-white absolute w-8 h-32 flex flex-col justify-center items-center text-center"
                   style={{
                     position: 'relative',
                     top: "0.5%",
                     left: "calc(1%)",
                   }}
              >
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                      backgroundImage: `url(${getImage("arrow_away")})`,
                      backgroundSize: "100% 100%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      opacity: 0.5,
                    }}
                />
                <p className="h-3 mt-1 z-10">{awayTeamData.ATTACK_LEFT}</p>
                <p className="[writing-mode:vertical-rl] [text-orientation:upright] mt-3 z-10">
                  왼쪽공격
                </p>
              </div>

              <div className="text-white absolute w-16 h-11 flex flex-col justify-center items-center text-center"
                   style={{
                     position: 'relative',
                     top: "-24%",
                     left: "calc(41%)",
                   }}
              >
                <div
                    className="absolute inset-0"
                    style={{
                      backgroundImage: `url(${getImage("arrow_away")})`,
                      backgroundSize: "100% 100%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      opacity: 0.5,
                    }}
                />
                <p className="z-10">{awayTeamData.ATTACK_MIDDLE}</p>
                <p className="z-10">중앙공격</p>
              </div>

              <div className="text-white absolute w-8 h-32 flex flex-col justify-center items-center text-center"
                   style={{
                     position: 'relative',
                     top: "-34%",
                     left: "calc(90%)",
                   }}
              >
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                      backgroundImage: `url(${getImage("arrow_away")})`,
                      backgroundSize: "100% 100%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      opacity: 0.5,
                    }}
                />
                <p className="h-3 mt-3 z-10">{awayTeamData.ATTACK_RIGHT}</p>
                <p className="[writing-mode:vertical-rl] [text-orientation:upright] mt-3 z-10">
                  오른쪽공격
                </p>
              </div>
            </div>

            {/* 선택한 선수 정보 */}
            {awayPlayerData && <PlayerDetailCard playerData={awayPlayerData[0]} setPlayerCode={setAwayPlayerCode}/>}

            {/* 운동장 선수 */}
            <div
                className="absolute inset-0 w-full h-[calc(100%-4rem)] transform translate-x-6 translate-y-14 flex flex-col justify-center text-white">
              {awayTeamData?.PLAYER?.map((player, index) => {
                const parsedStyles = parseCssString(player.cssHorizontal || "");
                let playerDetails = getPlayerDetailsByPlayerCode(player);

                if (playerDetails === '0.00') {
                  playerDetails = "-";
                }
                return (
                    <div
                        key={index}
                        className={neverLandUtils.classNames(playerDetails === "-" ? "opacity-50" : "", "absolute flex flex-col justify-center items-center")}
                        style={{
                          bottom: parsedStyles.bottom,
                          right: parsedStyles.right,
                        }}
                    >
                      {/*휴식일 / 키*/}
                      <div
                          className="flex flex-row justify-center p-1">
                        <p>{player.fday === "-" ? "" : player.fday + "일"}</p>
                        {(player.height && player.height !== "-") && <p>/{player.height}</p>}
                      </div>

                      {/*평점*/}
                      <div
                          className="flex flex-col bg-blue-800 rounded-full justify-center items-center p-2 min-w-11 h-7"
                          onClick={() => setAwayPlayerCode(player.code)}
                      >
                        <p>{playerDetails === '-' ? "" : playerDetails}</p>
                      </div>

                      {/*이름*/}
                      <p className="w-20 text-xs text-white text-center p-1 whitespace-nowrap overflow-hidden text-ellipsis truncate">
                        {player.name}
                      </p>

                      {/* 골키퍼일때 세이브 띄우기 */}
                      {(player.gk === '1' && player.saver_per) &&
                          <p className="text-xs text-white text-center p-1">
                            [ 세이브 : {player.saver_per} ]
                          </p>
                      }
                    </div>
                )
              })}
            </div>
          </div>

          {/* 벤치 플레이어 */}
          <div
              className="flex flex-row justify-start items-center bg-green-800 text-white w-full whitespace-nowrap overflow-scroll [&::-webkit-scrollbar]:hidden"
              style={{
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
          >
            <p className="text-xl py-2 bg-blue-600 px-2 mr-3">원정팀</p>
            <div className="flex flex-row mt-1">
              {awayTeamData?.BENCH_PLAYER?.map((player) => {
                let playerDetails = getPlayerDetailsByPlayerCode(player);

                if (playerDetails === '0.00') {
                  playerDetails = "-";
                }

                return (
                    <div
                        className="flex flex-col justify-center items-center mr-3"
                        onClick={() => setAwayPlayerCode(player.code)}
                    >
                      <p className=" bg-blue-400 text-black rounded-full px-2 py-1 min-w-9 text-center h-6">{playerDetails === '-' ? "" : playerDetails}</p>
                      <p>{player.name}</p>
                    </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
  )
}
export default PlayGround;